import { render } from "./Egyptian post office.vue?vue&type=template&id=12fee07a&scoped=true"
const script = {}

import "./Egyptian post office.vue?vue&type=style&index=0&id=12fee07a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-12fee07a"

export default script